(function () {
  if (window.__productMainRuntimeLoaded) return;
  window.__productMainRuntimeLoaded = true;

    // Keep gallery and swatch DOM measurement out of the LCP image path.
    function runAfterHeroImagePaint(callback) {
      if (window.__productMainInteractionRequested) {
        callback();
        return;
      }

      var scheduled = false;
      var completed = false;
      var fallbackTimer = null;

      function runCallback() {
        if (completed) return;
        completed = true;
        window.removeEventListener('product-main:interaction', runForInteraction);
        callback();
      }

      function runForInteraction() {
        if (fallbackTimer) window.clearTimeout(fallbackTimer);
        runCallback();
      }

      window.addEventListener('product-main:interaction', runForInteraction, { once: true });

      function runWhenIdle() {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(runCallback, { timeout: 1200 });
        } else {
          window.setTimeout(runCallback, 300);
        }
      }

      function schedule() {
        if (scheduled) return;
        scheduled = true;

        if (fallbackTimer) {
          window.clearTimeout(fallbackTimer);
        }

        if ('requestAnimationFrame' in window) {
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(runWhenIdle);
          });
          return;
        }

        window.setTimeout(runWhenIdle, 0);
      }

      function scheduleAfterDecode(image) {
        if (!image || typeof image.decode !== 'function') {
          schedule();
          return;
        }

        image.decode().then(schedule).catch(schedule);
      }

      function waitForHeroImage() {
        if (window.__productMainHeroReady) {
          schedule();
          return;
        }

        var activeSlide = document.querySelector('[data-media-slider] .product-media-slide.is-active');
        var heroImage = activeSlide ? activeSlide.querySelector('img.media-image') : null;

        fallbackTimer = window.setTimeout(schedule, 2500);

        if (activeSlide && !heroImage) {
          schedule();
          return;
        }

        heroImage = heroImage || document.querySelector('[data-media-slider] img.media-image');

        if (!heroImage || heroImage.complete) {
          scheduleAfterDecode(heroImage);
          return;
        }

        heroImage.addEventListener(
          'load',
          function () {
            scheduleAfterDecode(heroImage);
          },
          { once: true },
        );
        heroImage.addEventListener('error', schedule, { once: true });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', waitForHeroImage, { once: true });
      } else {
        waitForHeroImage();
      }
    }

    runAfterHeroImagePaint(function initializeProductSwatches() {
    if (!window.ProductSwatches) {
      window.addEventListener('product-swatches:ready', initializeProductSwatches, { once: true });
      return;
    }

    var initAllSliders = window.ProductSwatches.initAllSliders;
    var centerActive = window.ProductSwatches.centerActive;

    function normalizeSwatchOptionName(value) {
      return (value || '')
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function getSwatchLabelElement(swatchEl) {
      if (!swatchEl) return null;

      var optionName = normalizeSwatchOptionName(swatchEl.getAttribute('data-option-name'));
      if (!optionName) return null;

      var productRoot = swatchEl.closest('[data-product-main]') || document;
      return productRoot.querySelector('[data-option-' + optionName + '-label]');
    }

    function getActiveSwatchValue(swatchEl) {
      if (!swatchEl) return '';

      var optionName = normalizeSwatchOptionName(swatchEl.getAttribute('data-option-name'));
      if (!optionName) return '';

      var productRoot = swatchEl.closest('[data-product-main]') || document;
      var activeSwatch = productRoot.querySelector(
        'product-swatch[data-option-name="' + optionName + '"] .active-swatch[data-product-swatch]',
      );

      return activeSwatch && activeSwatch.parentElement
        ? activeSwatch.parentElement.getAttribute('data-option-value') || ''
        : '';
    }

    function previewSwatchLabel(swatchEl) {
      var labelEl = getSwatchLabelElement(swatchEl);
      if (!labelEl) return;

      var previewValue = swatchEl.getAttribute('data-option-value');
      if (!previewValue) return;

      labelEl.textContent = previewValue;
    }

    function restoreSwatchLabel(swatchEl) {
      var labelEl = getSwatchLabelElement(swatchEl);
      if (!labelEl) return;

      var activeValue = getActiveSwatchValue(swatchEl);
      var defaultValue = labelEl.getAttribute('data-default-option-value') || '';
      var restoredValue = activeValue || defaultValue;
      if (!restoredValue) return;

      labelEl.textContent = restoredValue;
    }

    document.addEventListener(
      'mouseover',
      function (event) {
        var swatchLink = event.target.closest('[data-product-swatch]');
        if (!swatchLink) return;

        var swatchEl = swatchLink.closest('product-swatch');
        if (!swatchEl) return;

        if (event.relatedTarget && swatchLink.contains(event.relatedTarget)) return;

        previewSwatchLabel(swatchEl);
      },
      true,
    );

    document.addEventListener(
      'mouseout',
      function (event) {
        var swatchLink = event.target.closest('[data-product-swatch]');
        if (!swatchLink) return;

        var swatchEl = swatchLink.closest('product-swatch');
        if (!swatchEl) return;

        if (event.relatedTarget && swatchLink.contains(event.relatedTarget)) return;

        restoreSwatchLabel(swatchEl);
      },
      true,
    );

    initAllSliders();

    // -------------------------------
    // MEDIA (HERO + THUMBS + DOTS)
    // Shared hero slider on mobile + desktop.
    // -------------------------------
    function isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function guardHeroModalOpeners(root) {
      root = root || document;

      var heroModalOpeners = root.querySelectorAll(
        '.product-images-wrapper .product-images-container modal-opener.product-media',
      );

      heroModalOpeners.forEach(function (opener) {
        if (opener.dataset.heroModalGuardBound === 'true') return;
        opener.dataset.heroModalGuardBound = 'true';

        opener.addEventListener(
          'click',
          function (e) {
            var mediaWrapper = opener.closest('[data-product-media-wrapper]');
            var mediaSlider = mediaWrapper ? mediaWrapper.querySelector('[data-media-slider]') : null;
            var suppressUntil = mediaSlider ? parseInt(mediaSlider.dataset.heroSwipeSuppressUntil || '0', 10) : 0;
            var suppressDueToSwipe = suppressUntil > Date.now();

            if (!suppressDueToSwipe) return;

            if (e.target && (e.target.tagName === 'VIDEO' || e.target.closest('video'))) {
              return;
            }

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
          },
          true,
        );
      });
    }

      function initMediaGallery(root) {
        root = root || document;

        var slider = root.querySelector('[data-media-slider]');
        var sliderViewport = root.querySelector('[data-media-slider-viewport]');
        var thumbsWrap = root.querySelector('[data-media-thumbs]');
        var mediaWrapper = root.querySelector('[data-product-media-wrapper]');
        var galleryModal = mediaWrapper ? mediaWrapper.querySelector('custom-modal-dialog.product-media-gallery') : null;
        var prevButton = root.querySelector('[data-media-nav="prev"]');
        var nextButton = root.querySelector('[data-media-nav="next"]');
        var zoomButton = root.querySelector('.zoom-svg-wrapper[data-modal-opener]');
        var imageModalOpeners = Array.from(
          root.querySelectorAll(
            '.product-images-container img[data-modal-opener][data-modal-media-index], .product-media-grid img[data-modal-opener][data-modal-media-index]',
          ),
        );
        if (!slider || !thumbsWrap) return;

      var currentSig =
        Array.from(slider.querySelectorAll('[data-media-slide]')).filter(function (node) {
          return node.getAttribute('data-media-clone') !== 'true';
        }).length +
        ':' +
        thumbsWrap.querySelectorAll('[data-thumb-index]').length;

      if (slider.dataset.mediaInit === 'true' && slider.dataset.mediaSig === currentSig && slider._mediaController) {
        return;
      }

      slider.querySelectorAll('[data-media-clone="true"]').forEach(function (node) {
        node.remove();
      });

      // Re-init safe: if media HTML changes after swatch/product switch,
      // we must rebind (old nodes/listeners become stale).
      if (slider._mediaController && typeof slider._mediaController.destroy === 'function') {
        slider._mediaController.destroy();
      }

      var slides = Array.from(slider.querySelectorAll('[data-media-slide]'));
      var thumbs = Array.from(thumbsWrap.querySelectorAll('[data-thumb-index]'));

      // If nothing to bind, stop
      if (!slides.length || !thumbs.length) return;

      // Mark init + remember counts so we can detect changes
      slider.dataset.mediaInit = 'true';
      slider.dataset.mediaSig = currentSig;

      // Store handlers so we can remove them on re-init
      var controller = {
        destroy: function () {
          // remove listeners we add below (no-op if not attached yet)
          try {
            slider.removeEventListener('touchstart', onHeroTouchStart, { passive: true });
          } catch (e) {}
          try {
            slider.removeEventListener('touchstart', onHeroTouchStart);
          } catch (e) {}
          try {
            slider.removeEventListener('touchmove', onHeroTouchMove, { passive: true });
          } catch (e) {}
          try {
            slider.removeEventListener('touchmove', onHeroTouchMove);
          } catch (e) {}
          try {
            slider.removeEventListener('touchend', onHeroTouchEnd, { passive: true });
          } catch (e) {}
          try {
            slider.removeEventListener('touchend', onHeroTouchEnd);
          } catch (e) {}

          thumbs.forEach(function (btn) {
            btn.removeEventListener('click', onThumbClick);
          });

          if (prevButton) {
            prevButton.removeEventListener('click', onPrevClick);
          }

          if (nextButton) {
            nextButton.removeEventListener('click', onNextClick);
          }

          if (zoomButton) {
            zoomButton.removeEventListener('click', onZoomModalOpen);
          }

          if (viewSpecsBtn) {
            viewSpecsBtn.removeEventListener('click', onViewSpecsClick);
          }

          imageModalOpeners.forEach(function (opener) {
            opener.removeEventListener('click', onImageModalOpen);
          });

          if (dots && dots.length) {
            dots.forEach(function (btn) {
              btn.removeEventListener('click', onDotClick);
            });
          }

          slider.removeEventListener('transitionend', onSliderTransitionEnd);

          slider.querySelectorAll('[data-media-clone="true"]').forEach(function (node) {
            node.remove();
          });
        },
      };
      slider._mediaController = controller;

      // Dots wrapper (you already have: <div class="slider-dots slider-dots--below-thumbs"></div>)
      var dotsWrap = root.querySelector('.slider-dots');
      var dots = [];
      // -------------------------------
      // VIEW SPECS
      // Shows the image whose alt includes "specification"
      // -------------------------------
      var viewSpecsBtn = root.querySelector('#view-specification-button');

      function onViewSpecsClick(e) {
        e.preventDefault();
        e.stopPropagation();

        var specIndex = findSpecsIndex();
        if (specIndex >= 0) {
          setActive(specIndex);
        }
      }

      function findSpecsIndex() {
        // Look through slides and find an <img alt="specification">
        for (var i = 0; i < slides.length; i++) {
          var img = slides[i].querySelector('img.media-image');
          if (!img) continue;

          var alt = (img.getAttribute('alt') || '').trim().toLowerCase();
          if (alt.indexOf('specification') !== -1) return i;
        }
        return -1;
      }
      function onDotClick(e) {
        var idx = parseInt(e.currentTarget.getAttribute('data-dot-index'), 10);
        if (!isNaN(idx)) setActiveUI(idx, true);
      }

      function isVideoGestureTarget(target) {
        return !!getVideoGestureElement(target);
      }

      function getVideoGestureElement(target) {
        if (!target || !target.closest) return false;

        return target.closest(
          'video, iframe, .media-video-wrapper, .product-media-grid-video, .zoom-product-media',
        );
      }

      function isAppleTouchDevice() {
        var ua = window.navigator.userAgent || '';
        var platform = window.navigator.platform || '';

        return /iPad|iPhone|iPod/.test(ua) || (platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
      }

      function getPrimaryTouch(event) {
        if (event.touches && event.touches[0]) return event.touches[0];
        if (event.changedTouches && event.changedTouches[0]) return event.changedTouches[0];

        return null;
      }

      function isTouchInLowerVideoControlZone(event) {
        if (!isAppleTouchDevice()) return false;

        var touch = getPrimaryTouch(event);
        var mediaEl = getVideoGestureElement(event.target);
        if (!touch || !mediaEl) return false;

        var rect = mediaEl.getBoundingClientRect();
        if (!rect || !rect.height) return false;

        return touch.clientY >= rect.top + rect.height * 0.8;
      }

      function buildDots() {
        if (!dotsWrap) return;

        dotsWrap.innerHTML = '';
        dots = [];

        for (var i = 0; i < slides.length; i++) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'slider-dot';
          btn.setAttribute('aria-label', 'Go to image ' + (i + 1));
          btn.setAttribute('data-dot-index', String(i));

          // Force ROUND dots (inline styles override theme CSS)
          btn.style.width = '10px';
          btn.style.height = '10px';
          btn.style.borderRadius = '999px';
          btn.style.padding = '0';
          btn.style.border = '1px solid #111';
          btn.style.background = 'transparent';
          btn.style.display = 'inline-block';

          btn.addEventListener('click', onDotClick);

          dotsWrap.appendChild(btn);
          dots.push(btn);
        }
      }

      var initialActiveIndex = slides.findIndex(function (slide) {
        return slide.classList.contains('is-active');
      });
      var currentMediaIndex = initialActiveIndex >= 0 ? initialActiveIndex : 0;
      var renderedSlides = slides.slice();
      var pendingLoopSnapIndex = null;
      var startX = 0;
      var startY = 0;
      var dragOffsetX = 0;
      var gestureStarted = false;
      var dragAxisLocked = false;
      var isHorizontalDrag = false;

      function buildLoopSlides() {
        renderedSlides = slides.slice();

        if (slides.length <= 1) return;

        var firstClone = slides[0].cloneNode(true);
        var lastClone = slides[slides.length - 1].cloneNode(true);

        [firstClone, lastClone].forEach(function (clone) {
          clone.setAttribute('data-media-clone', 'true');
          clone.classList.remove('is-active');
        });

        slider.insertBefore(lastClone, slider.firstChild);
        slider.appendChild(firstClone);

        renderedSlides = Array.from(slider.querySelectorAll('[data-media-slide]'));
      }

      function getVisibleWidth() {
        return sliderViewport
          ? sliderViewport.getBoundingClientRect().width
          : mediaWrapper
            ? mediaWrapper.getBoundingClientRect().width
            : slider.getBoundingClientRect().width;
      }

      function getRenderIndexForLogicalIndex(index) {
        if (slides.length <= 1) return index;
        return index + 1;
      }

      function moveTrackToRenderIndex(renderIndex, animate) {
        var visibleWidth = getVisibleWidth();

        if (animate === false) {
          slider.style.transition = 'none';
          slider.style.transform = 'translate3d(' + visibleWidth * renderIndex * -1 + 'px, 0, 0)';
          slider.offsetHeight;
          slider.style.transition = '';
          return;
        }

        slider.style.transition = '';
        slider.style.transform = 'translate3d(' + visibleWidth * renderIndex * -1 + 'px, 0, 0)';
      }

      function getTrackTranslateForLogicalIndex(index) {
        return getVisibleWidth() * getRenderIndexForLogicalIndex(index) * -1;
      }

      function onHeroTouchStart(e) {
        if (!e.touches || !e.touches.length || pendingLoopSnapIndex !== null) return;
        if (isVideoGestureTarget(e.target) && isTouchInLowerVideoControlZone(e)) {
          gestureStarted = false;
          dragAxisLocked = false;
          isHorizontalDrag = false;
          dragOffsetX = 0;
          return;
        }

        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        dragOffsetX = 0;
        gestureStarted = true;
        dragAxisLocked = false;
        isHorizontalDrag = false;
        slider.style.transition = 'none';
      }

      function onHeroTouchMove(e) {
        if (!gestureStarted || !e.touches || !e.touches.length) return;

        var touch = e.touches[0];
        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;

        if (!dragAxisLocked) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          dragAxisLocked = true;
          isHorizontalDrag = Math.abs(dx) > Math.abs(dy);
        }

        if (!isHorizontalDrag) return;

        dragOffsetX = dx;
        slider.style.transform =
          'translate3d(' + (getTrackTranslateForLogicalIndex(currentMediaIndex) + dragOffsetX) + 'px, 0, 0)';
      }

      function onHeroTouchEnd(e) {
        if (!gestureStarted) return;

        var touch = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0] : null;
        if (!touch) {
          gestureStarted = false;
          dragAxisLocked = false;
          isHorizontalDrag = false;
          dragOffsetX = 0;
          moveTrackToRenderIndex(getRenderIndexForLogicalIndex(currentMediaIndex), true);
          return;
        }

        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;
        var visibleWidth = getVisibleWidth();
        var swipeThreshold = Math.min(Math.max(visibleWidth * 0.18, 40), 120);

        gestureStarted = false;
        dragAxisLocked = false;

        if (!isHorizontalDrag || Math.abs(dy) > Math.abs(dx)) {
          isHorizontalDrag = false;
          dragOffsetX = 0;
          moveTrackToRenderIndex(getRenderIndexForLogicalIndex(currentMediaIndex), true);
          return;
        }

        isHorizontalDrag = false;
        dragOffsetX = 0;
        slider.dataset.heroSwipeSuppressUntil = String(Date.now() + 450);

        if (dx <= -swipeThreshold) {
          goNext();
          return;
        }

        if (dx >= swipeThreshold) {
          goPrev();
          return;
        }

        moveTrackToRenderIndex(getRenderIndexForLogicalIndex(currentMediaIndex), true);
      }

      function syncMediaOverlayControls(index) {
        if (!mediaWrapper) return;

        var activeSlide = slides[index];
        var mediaType = activeSlide ? activeSlide.getAttribute('data-media-type') : '';
        var isVideoMedia = mediaType === 'video' || mediaType === 'external_video';

        mediaWrapper.classList.toggle('has-active-video-media', isVideoMedia);
      }

      function syncMediaNavButtons(index) {
        var disablePrev = slides.length <= 1;
        var disableNext = slides.length <= 1;

        if (prevButton) {
          prevButton.disabled = disablePrev;
          prevButton.setAttribute('aria-disabled', disablePrev ? 'true' : 'false');
        }

        if (nextButton) {
          nextButton.disabled = disableNext;
          nextButton.setAttribute('aria-disabled', disableNext ? 'true' : 'false');
        }
      }

      function scrollGalleryModalToIndex(index) {
        if (!galleryModal) return;

        if (index < 0) index = 0;
        if (index >= slides.length) index = slides.length - 1;

        var selector = '[data-modal-media-index="' + index + '"]';
        var target = galleryModal.querySelector(selector);
        if (!target) return;

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            target.scrollIntoView({
              behavior: 'auto',
              block: 'start',
              inline: 'nearest',
            });
          });
        });
      }

      function onSliderTransitionEnd(e) {
        if (e.target !== slider || pendingLoopSnapIndex === null) return;

        moveTrackToRenderIndex(getRenderIndexForLogicalIndex(pendingLoopSnapIndex), false);
        pendingLoopSnapIndex = null;
      }

      function setActiveUI(index, shouldScroll, options) {
        if (shouldScroll === undefined) shouldScroll = true;
        options = options || {};

        // SAFETY: clamp index
        if (index < 0) index = 0;
        if (index >= slides.length) index = slides.length - 1;
        currentMediaIndex = index;
        if (zoomButton) {
          zoomButton.setAttribute('data-modal-media-index', String(index));
        }

        // Slides: keep all slides in the track and move the track.
        slides.forEach(function (s, i) {
          s.classList.toggle('is-active', i === index);
          s.style.display = '';
        });

        if (options.wrapToStartClone) {
          pendingLoopSnapIndex = index;
          moveTrackToRenderIndex(renderedSlides.length - 1, true);
        } else if (options.wrapToEndClone) {
          pendingLoopSnapIndex = index;
          moveTrackToRenderIndex(0, true);
        } else {
          pendingLoopSnapIndex = null;
          moveTrackToRenderIndex(getRenderIndexForLogicalIndex(index), options.animate !== false);
        }

        syncMediaOverlayControls(index);
        syncMediaNavButtons(index);

        // Thumbs
        thumbs.forEach(function (thumb) {
          thumb.classList.remove('is-active');
        });

        var activeThumb = thumbsWrap.querySelector('[data-thumb-index="' + index + '"]');
        if (activeThumb) {
          activeThumb.classList.add('is-active');

          // IMPORTANT: only scroll thumbs into view if the gallery is on-screen.
          // This prevents the page snapping back up when you are below Add to Cart.
          var wrapRect = thumbsWrap.getBoundingClientRect();
          var galleryIsVisible = wrapRect.bottom > 0 && wrapRect.top < window.innerHeight;

          if (galleryIsVisible) {
            try {
              activeThumb.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center',
              });
            } catch (e) {}
          }
        }

        // Dots
        if (dots && dots.length) {
          dots.forEach(function (d, i) {
            d.classList.toggle('is-active', i === index);
            d.style.background = i === index ? '#111' : 'transparent';
          });
        }
      }

      function setActive(index) {
        setActiveUI(index);
      }

      function onThumbClick(e) {
        var btn = e.currentTarget;
        var idx = parseInt(btn.getAttribute('data-thumb-index'), 10);
        if (!isNaN(idx)) setActiveUI(idx, true);
      }

      function onPrevClick(e) {
        if (e) e.preventDefault();
        goPrev();
      }

      function onNextClick(e) {
        if (e) e.preventDefault();
        goNext();
      }

      function onImageModalOpen(e) {
        var idx = parseInt(e.currentTarget.getAttribute('data-modal-media-index'), 10);
        if (isNaN(idx)) return;
        scrollGalleryModalToIndex(idx);
      }

      function onZoomModalOpen() {
        scrollGalleryModalToIndex(currentMediaIndex);
      }

      function isolateOverlayControlTouch(control) {
        if (!control || control.dataset.touchIsolationBound === 'true') return;
        control.dataset.touchIsolationBound = 'true';

        ['touchstart', 'touchmove', 'touchend'].forEach(function (eventName) {
          control.addEventListener(
            eventName,
            function (event) {
              event.stopPropagation();
            },
            { passive: eventName !== 'touchend' },
          );
        });
      }

      function isolateVideoControlTouch() {
        slider.querySelectorAll('video, iframe, .media-video-wrapper').forEach(function (mediaControl) {
          if (!mediaControl || mediaControl.dataset.videoTouchIsolationBound === 'true') return;
          mediaControl.dataset.videoTouchIsolationBound = 'true';

          ['touchstart', 'touchmove', 'touchend', 'touchcancel'].forEach(function (eventName) {
            mediaControl.addEventListener(
              eventName,
              function (event) {
                if (isTouchInLowerVideoControlZone(event)) {
                  event.stopPropagation();
                }
              },
              { passive: true },
            );
          });
        });
      }

      // Thumb clicks
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', onThumbClick);
      });

      if (prevButton) {
        isolateOverlayControlTouch(prevButton);
        prevButton.addEventListener('click', onPrevClick);
      }

      if (nextButton) {
        isolateOverlayControlTouch(nextButton);
        nextButton.addEventListener('click', onNextClick);
      }

      if (zoomButton) {
        isolateOverlayControlTouch(zoomButton);
        zoomButton.addEventListener('click', onZoomModalOpen);
      }

      imageModalOpeners.forEach(function (opener) {
        if (opener.dataset.productMediaModalBound === 'true') return;
        opener.dataset.productMediaModalBound = 'true';
        opener.addEventListener('click', onImageModalOpen);
      });

      isolateOverlayControlTouch(viewSpecsBtn);
      if (viewSpecsBtn) {
        viewSpecsBtn.addEventListener('click', onViewSpecsClick);
      }

      isolateVideoControlTouch();

      function getCurrentIndex() {
        return currentMediaIndex;
      }

      function goPrev() {
        var current = getCurrentIndex();
        var prev = current - 1;

        if (slides.length <= 1) {
          setActive(0);
          return;
        }

        if (prev < 0) {
          setActiveUI(slides.length - 1, true, { wrapToEndClone: true });
          return;
        }

        setActive(prev);
      }

      function goNext() {
        var current = getCurrentIndex();
        var next = current + 1;

        if (slides.length <= 1) {
          setActive(0);
          return;
        }

        if (next >= slides.length) {
          setActiveUI(0, true, { wrapToStartClone: true });
          return;
        }

        setActive(next);
      }

      // Bind swipe on the visible hero area (more reliable than binding only on slider)
      function getHeroSwipeTarget() {
        return slider; // bind to the track for slide mode
      }

      function bindHeroSwipe() {
        var target = getHeroSwipeTarget();
        if (!target || target.dataset.heroSwipeBound === 'true') return;
        target.dataset.heroSwipeBound = 'true';

        target.addEventListener('touchstart', onHeroTouchStart, { passive: true });
        target.addEventListener('touchmove', onHeroTouchMove, { passive: true });
        target.addEventListener('touchend', onHeroTouchEnd, { passive: true });
      }

      // bind once for initial active slide
      bindHeroSwipe();
      buildLoopSlides();
      isolateVideoControlTouch();
      slider.addEventListener('transitionend', onSliderTransitionEnd);

      // Init
      buildDots();
      setActiveUI(currentMediaIndex, false, { animate: false });

      // On resize: keep current index and refresh layout
      window.addEventListener('resize', function () {
        if (isMobile()) {
          // rebuild dots in case layout changed
          buildDots();
          // keep current active index if possible
          var current = 0;
          var activeThumb = thumbsWrap.querySelector('.product-media-thumb.is-active');
          if (activeThumb) {
            var v = parseInt(activeThumb.getAttribute('data-thumb-index'), 10);
            if (!isNaN(v)) current = v;
          }
          currentMediaIndex = current;
        }
        setActiveUI(currentMediaIndex, false, { animate: false });
        guardHeroModalOpeners(document);
      });
    }

    // Run once on initial load
    guardHeroModalOpeners(document);
    initMediaGallery(document);
    // -------------------------------
    // TAB TITLE SYNC (fixes URL updates without title refresh)
    // Updates the browser tab title when product swaps happen via swatches
    // -------------------------------
    (function initTabTitleSync() {
      // Preserve the existing title suffix like " | ATS Tiles & Bathrooms"
      // so we only replace the product part.
      var initialTitle = document.title || '';
      var titleSuffix = '';
      if (initialTitle.indexOf('|') !== -1) {
        titleSuffix = initialTitle.split('|').slice(1).join('|').trim();
      }

      var rafPending = false;

      function getCurrentProductTitle() {
        var h1 = document.querySelector('[data-product-main] .product-title');
        if (!h1) return '';
        return (h1.textContent || '').trim();
      }

      function setDocumentTitleFromDOM() {
        var productTitle = getCurrentProductTitle();
        if (!productTitle) return;

        var nextTitle = titleSuffix ? productTitle + ' | ' + titleSuffix : productTitle;

        // Avoid repeatedly setting the same title
        if (document.title !== nextTitle) {
          document.title = nextTitle;
        }
      }

      function scheduleTitleUpdate() {
        if (rafPending) return;
        rafPending = true;
        requestAnimationFrame(function () {
          rafPending = false;
          setDocumentTitleFromDOM();
        });
      }

      // Initial set (covers first load and cases where theme title is different)
      setDocumentTitleFromDOM();

      // Watch for product swaps or title updates in the DOM
      var titleRoot = document.querySelector('[data-product-main]') || document.body;

      var titleObserver = new MutationObserver(function () {
        scheduleTitleUpdate();
      });

      titleObserver.observe(titleRoot, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    })();

    // -------------------------------
    // Mutation observer for re-renders (swatch change)
    // -------------------------------
    var swatchRoot = document.querySelector('[data-product-main]') || document.body;
    var enhancementFrame = null;
    var pendingMedia = false;
    var pendingSwatches = false;
    var activeSliders = new Set();

    function scheduleProductEnhancements() {
      if (enhancementFrame !== null) return;
      enhancementFrame = window.requestAnimationFrame(function () {
        enhancementFrame = null;
        if (pendingSwatches) initAllSliders(swatchRoot);
        if (pendingMedia) {
          initMediaGallery(swatchRoot);
          guardHeroModalOpeners(swatchRoot);
        }
        activeSliders.forEach(function (slider) {
          if (slider.isConnected) centerActive(slider);
        });
        activeSliders.clear();
        pendingMedia = false;
        pendingSwatches = false;
      });
    }

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'childList') {
          m.addedNodes.forEach(function (node) {
            if (!(node instanceof HTMLElement)) return;

            if (node.matches && node.matches('[data-swatch-slider]')) {
              pendingSwatches = true;
            }

            if (node.querySelector && node.querySelector('[data-swatch-slider]')) {
              pendingSwatches = true;
            }

            // If product media got re-rendered, init again (new node = new dataset)
            if (
              (node.matches && (node.matches('[data-media-slider]') || node.matches('[data-media-thumbs]'))) ||
              (node.querySelector &&
                (node.querySelector('[data-media-slider]') || node.querySelector('[data-media-thumbs]')))
            ) {
              pendingMedia = true;
            }
            if (pendingSwatches || pendingMedia) scheduleProductEnhancements();
          });
        }

        // active-swatch class changes (existing behaviour)
        if (m.type === 'attributes' && m.attributeName === 'class') {
          var target = m.target;
          if (!target.classList) return;

          if (target.classList.contains('product-swatch') && target.classList.contains('active-swatch')) {
            var slider = target.closest('[data-swatch-slider]');
            if (slider) {
              activeSliders.add(slider);
              scheduleProductEnhancements();
            }
          }
        }
      });
    });

    observer.observe(swatchRoot, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    window.__productMainEnhancementsReady = true;
    window.dispatchEvent(new CustomEvent('product-main:ready'));
    });
  })();
